.palette {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-3);
  padding: var(--hcr-spacing-3);
  border: 1px solid var(--hcr-line-primary-color);
  border-radius: var(--hcr-border-radius-2);
}

.paletteSectionLabel {
  font-weight: 700;
  margin-bottom: var(--hcr-spacing-1);
  color: var(--hcr-content-primary-color);
}

.paletteChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--hcr-spacing-2);
}

.paletteTip {
  color: var(--hcr-content-secondary-color);
  font-size: var(--hcr-font-size-small);
}
